
export function getSupplierShortname (long) {
	return (" "+long).replace(/[^ ][A-ZÄÖÜ]/g,"").replace(/[^A-ZÄÖÜ]/g,"");
} 

export function getMixtureShortname (long) {
	return long.replace(/ /g,"");
} 